// Microsoft Clarity session recording/heatmaps.
// No-ops unless REACT_APP_CLARITY_PROJECT_ID is set (dev env files only for
// now) and it looks like a real ID — so stage/prod builds stay Clarity-free
// until the var is added to their env files. Unlike analytics/index.js this
// is NOT production-gated: presence of the ID is the gate.
export const initClarity = () => {
    const id = process.env.REACT_APP_CLARITY_PROJECT_ID;
    if (!id || id.startsWith("YOUR_")) return;
    if (window.clarity) return; // once per page
    (function (c, l, a, r, i, t, y) {
        c[a] = c[a] || function () { (c[a].q = c[a].q || []).push(arguments); };
        t = l.createElement(r); t.async = 1; t.src = "https://www.clarity.ms/tag/" + i;
        y = l.getElementsByTagName(r)[0]; y.parentNode.insertBefore(t, y);
    })(window, document, "clarity", "script", id);
};

// Custom tag for filtering recordings in the Clarity dashboard
// (e.g. clarityTag("appType", "firetv")). Safe no-op when Clarity isn't loaded.
export const clarityTag = (key, value) => {
    try { window.clarity?.("set", key, value); } catch { /* never break the app */ }
};
